import { defineComponent } from 'vue'
import './index.scss'
import { GfrContainer, ModuleBase, GfrButton, CommonDownload, NuxtLink, IconsOutArrow } from '#components'
import { moduleBaseProps } from '@/components/module/base'
export default defineComponent({
  name: 'ModuleHomeScreen1',
  props: {
    ...moduleBaseProps,
    content: String,
    description: String,
    buttonGroup: {
      type: Array as PropType<
        {
          name: string
          url: string
          download: boolean
        }[]
      >,
      default: () => []
    }
  },
  setup(props, { slots }) {
    const { config } = storeToRefs(useStore())
    return () => (
      <ModuleBase
        name={props.name}
        class={'module-home-intro-base'}
        hasVideo={props.backgroundVideo !== ''}
        video={props.backgroundVideo}
        desktopBackground={props.image_pc}
        mobileBackground={props.image_mobile}
        videoPoster={props.image_pc}
      >
        <GfrContainer class={['module-home-intro']}>
          {props.content && <h2 class={'module-home-intro-slogan'}>{props.content}</h2>}
          {props.description && <p class={'module-home-intro-desc'}>{props.description}</p>}
          {props.buttonGroup.length > 0 && (
            <div class={['module-home-intro-button-group']}>
              {props.buttonGroup.map((item) => {
                if (item.url && !item.download) {
                  return (
                    <NuxtLink
                      to={item.url}
                      class="mr-10 max-lg:portrait:mr-5 first:ml-0 last:mr-0"
                      target={isSameOriginUrl(item.url) ? '_self' : '_blank'}
                    >
                      <GfrButton class="module-home-btn">
                        {item.name}
                        <IconsOutArrow class="ml-1 h-3.5 w-3.5 rtl:ml-0 rtl:mr-1 rtl:-rotate-90" />
                      </GfrButton>
                    </NuxtLink>
                  )
                } else if (item.download && !config.value.is_ind) {
                  return <CommonDownload class="mr-10 max-lg:portrait:mr-5 last:mr-0 max-lg:hidden" size="large" />
                }
                return null
              })}
            </div>
          )}
          {slots.default?.()}
        </GfrContainer>
      </ModuleBase>
    )
  }
})
